import { ThemeProvider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Loader from 'UI/loader';
import Navbar from 'UI/navbar';
import NotificationPermission from 'UI/notificationPermission';
import OfflineNotifier from 'UI/offlineNotifier';
import Snackbar from 'UI/snackbar';
import axios from 'axios';
import ChaseScoreModal from 'components/chaseScoreModal/chaseScoreModal';
import DailyReportModal from 'components/dashboard/dailyReportModal';
import TravClanQuoteModal from 'components/dashboard/travClanQuoteModal';
import PerfModal from 'components/perfModal/perfModal';
import RequestPackModal from 'components/requestPackModal/requestPackModal';
import AiItineraryBuilder from 'containers/aiItineraryBuilder/aiItineraryBuilderRedux';
import { getExpertDetails, logout, updateToken } from 'containers/auth/authActions';
import Auth from 'containers/auth/authRedux';
import { getParams, pingUser, registerNotifToken } from 'containers/common/commonActions';
import Dashboard from 'containers/dashboard/dashboardRedux';
import ItineraryMaker from 'containers/itineraryMaker/itineraryMakerRedux';
import { getNotifications } from 'containers/notification/notificationActions';
import * as _ from 'lodash';
import throttle from 'lodash/throttle';
import moment from 'moment';
import * as PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Redirect,
  Route,
  Switch,
  withRouter
} from 'react-router-dom';
import { baseURL } from 'utils/apiEndpoints';
import {
  deleteCookies, getCookies, headerGenerator, isEqual, setCookie
} from 'utils/common';
import { ROLES } from 'utils/consts';
import TemplatesIndex from './containers/templates/templatesRedux';
import theme from './theme';

// const METABASE_SITE_URL = 'https://meta.flynote.com';
// const METABASE_SECRET_KEY = '123';

// eslint-disable-next-line
// const LazyLoad = ({ Component, ...rest }) => (
//   <Suspense fallback={<div className="loader"><Loader /></div>}>
//     <Component {...rest} />
//   </Suspense>
// );

// const LazyMaker = React.lazy(() => import('./containers/itineraryMaker/itineraryMakerRedux'));
// const LazyInventory = React.lazy(() => import('./containers/inventory/inventoryRedux'));

class App extends Component {
  constructor(props) {
    super(props);

    const { getExpertDetails: getExpDetails } = this.props;
    this.poller = null;
    this.notifPoller = null;
    this.headers = headerGenerator('');
    const cookies = getCookies();
    let loggedIn = false;
    if (cookies.token) {
      loggedIn = true;
      this.headers = headerGenerator(cookies.token);
      this.setExpert();
      getExpDetails({}, this.headers);
      this.pollHandler();
      this.poller = setInterval(() => this.pollHandler(), 30000);
      this.notifPoller = setInterval(() => this.notifPollHandler(), 120000);
    }
    const isOffline = !navigator.onLine;
    this.state = {
      loggedIn,
      open: false,
      msg: '',
      variant: 'info',
      actions: [],
      notifPopup: false,
      feedbackDialog: false,
      error: null,
      errorInfo: '',
      offlineSnack: isOffline,
      showPerfModal: null,
      showRequestPackModal: (new URLSearchParams(window.location.search)).get('orpm') === 'true',
      travClanQuoteDialog: false,
      dailyReport: null,
    };
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', this.workerMsgHandler);
    }
  }

  // componentDidCatch = (error, errorInfo) => {
  //   this.setState({ error, errorInfo });
  // }

  componentDidUpdate = (prevProps) => {
    const {
      loginResp,
      history,
      notifications,
      unReadCount,
      getExpertDetailsError,
    } = this.props;
    const { loginResp: prevLoginResp } = prevProps;
    const { showPerfModal, dailyReport } = this.state;
    const { expert } = loginResp || {};
    if (expert
      && !expert.roles.includes(ROLES.TEAM_LEAD)
      && window.location.href.includes('dashboard')
      && showPerfModal === null
      && window.localStorage.getItem('showPerfModal') !== moment().format('YYYY-MM-DD')) {
      this.setState({ showPerfModal: true });
      window.localStorage.setItem('showPerfModal', moment().format('YYYY-MM-DD'));
    }
    if (expert?.roles?.includes(ROLES.TEAM_LEAD)
      && (_.isNil(dailyReport)
        || !_.isEqual(prevLoginResp?.expert?.dailyReport, expert?.dailyReport))
    ) {
      this.setState({
        dailyReport: expert?.dailyReport || {},
      });
    }
    if (!isEqual(loginResp, prevProps.loginResp) && loginResp.token) {
      if (window.location.href.includes('login')) {
        history.replace('/');
      }
      this.setState({ loggedIn: true });
      setCookie({ token: loginResp.token });
      window.localStorage.setItem('expert', JSON.stringify(loginResp.expert));
      this.headers = headerGenerator(loginResp.token);
      this.postLoginHandler();
      if (!this.poller) {
        this.pollHandler();
        this.poller = setInterval(() => this.pollHandler(), 30000);
      }
      if (this.notifPoller) {
        this.notifPollHandler();
        this.notifPoller = setInterval(() => this.notifPollHandler(), 120000);
      }
    }
    if (!isEqual(notifications, prevProps.notifications) && notifications.length
      && prevProps.notifications.length) {
      this.showSnackbar('You have a new notification', 'success');
    }
    if (!isEqual(unReadCount, prevProps.unReadCount) && unReadCount) {
      this.showSnackbar('You have a new notification', 'success');
    }
    // if (!isEqual(getExpertDetailsError, prevProps.getExpertDetailsError) && getExpertDetailsError) {
    //   this.showSnackbar('Error getting expert', 'error');
    //   console.log('#### componentDidUpdate getExpertDetailsError');
    //   this.logOutHandler();
    // }
  };

  setExpert = () => {
    const { updateToken: updateTkn } = this.props;
    const expert = window.localStorage.getItem('expert');
    if (expert) {
      try {
        updateTkn({ ...getCookies(), expert: JSON.parse(expert) });
      } catch (err) {
        this.logOutHandler();
      }
    } else {
      this.logOutHandler();
    }
  };

  postLoginHandler = () => {
    const { getParamsMeta, getNotifs } = this.props;
    this.checkNotifPermission();
    this.idleTimer = setTimeout(this.toggleActiveUser, 30000);
    document.addEventListener('mousemove', this.resetTimer);
    document.addEventListener('keypress', this.resetTimer);
    getParamsMeta({}, this.headers);
    getNotifs({
      skip: 0,
      limit: 15,
    }, this.headers);
    window.addEventListener('offline', () => { this.setState({ offlineSnack: true }); });
    window.addEventListener('online', () => { this.setState({ offlineSnack: false }); });
    // if (!window.origin.includes('localhost')) {
    //   window.onbeforeunload = (e) => {
    //     e.preventDefault();
    //     e.returnValue = 'Are you sure, want to quit?';
    //   };
    // }
  };

  checkNotifPermission = () => {
    const currPermission = Notification.permission;
    if (currPermission !== 'granted') {
      Notification.requestPermission()
        .then((newPermission) => {
          if (newPermission === 'granted') {
            this.showSnackbar('Great, you will receive notifications now', 'success');            
          } else {
            this.showSnackbar('Please enable notifications to receive trip & request updates', 'warning');
          }
        });
    }
  };

  playNotificationSound = (soundUrl) => {
    try {
      const audio = new Audio(soundUrl || 'https://s3.ap-south-1.amazonaws.com/flynotemedia/images/sounds/quite-impressed.mp3');
      audio.play().catch((err) => {
        // Some browsers may block autoplay, this is expected
        console.log('Could not play notification sound:', err);
      });
    } catch (err) {
      console.log('Error playing notification sound:', err);
    }
  };

  workerMsgHandler = (evt) => {
    const { registerToken } = this.props;
    if (evt.data.notificationToken) {
      registerToken(evt.data, this.headers);
    } else if (evt.data.notification) {
      const { notification } = evt.data;
      // Play notification sound
      // this.playNotificationSound(notification.sound);
      // Check if Notification API is available and send to service worker to show notification
      if ('Notification' in window && Notification.permission === 'granted') {
        try {
          const notif = new Notification(notification.title, {

            badge: notification.badge,
            body: notification.body || '',
            icon: notification.icon,
            // vibrate: notification.vibrate,
            // // requireInteraction: notification.requireInteraction,
            // silent: notification.silent,
            data: notification.data,
            // renotify: notification.renotify,
          });
            
          notif.onclick = () => {
            console.log('#### notification onclick event fired');
            notif.close();
            // Switch to tab matching notification.data.url if it exists
            if (notification?.data?.url && navigator?.serviceWorker?.controller) {
              const currentUrl = new URL(window.location.href);
              const notificationUrl = new URL(notification.data.url, window.location.origin);
              // Only send FOCUS_TAB if current tab doesn't match the notification URL
              if (currentUrl.href !== notificationUrl.href) {
                try {
                  // Double-check controller is still available (might have changed)
                  const controller = navigator.serviceWorker.controller;
                  if (controller) {
                    controller.postMessage({
                      type: 'FOCUS_TAB',
                      relativeUrl: notification.data.url,
                    });
                  }
                } catch (err) {
                  // Silently handle errors - service worker might be updating/terminating
                  // This is expected during service worker updates and is harmless
                  // The error "message port closed" occurs when SW terminates mid-message
                  if (err.message && !err.message.includes('message port closed')) {
                    console.log('Service worker postMessage error:', err.message);
                  }
                }
              }
            }
          };
            
          // Store notification reference to prevent garbage collection
          if (!window.activeNotifications) {
            window.activeNotifications = [];
          }
          window.activeNotifications.push(notif);
            
          // Don't auto-close if requireInteraction is true - let user dismiss it
          // But set a longer timeout just in case
          setTimeout(() => {
            if (notif && window.activeNotifications.includes(notif)) {
              // console.log('#### auto-closing notification after 30 seconds');
              notif.close();
              // Remove from array
              const index = window.activeNotifications.indexOf(notif);
              if (index > -1) {
                window.activeNotifications.splice(index, 1);
              }
            }
          }, 30000); // Increased to 30 seconds
        } catch (err) {
          console.log('#### direct notification error, falling back to service worker:', err);
        }
      } else {
        console.log('#### notification permission not granted');
        // Page is hidden - use service worker
        this.showSnackbar('Please enable notifications', 'error');
      }
    } else if (evt.data.update) {
      this.showSnackbar('Update is available', 'info', [{
        title: 'UPDATE',
        action: () => {
          window.onbeforeunload = undefined;
          window.location.reload();
        },
      }]);
    }
  };

  logOutHandler = () => {
    const { history, logOut } = this.props;
    this.setState({ loggedIn: false });
    clearInterval(this.poller);
    clearInterval(this.notifPoller);
    clearInterval(this.idleTimer);
    deleteCookies(['token', 'message', 'state']);
    window.localStorage.clear();
    if (caches) {
      caches.keys()
        .then((cacheNames) => {
          for (let i = 0; i < cacheNames.length; i++) {
            if (cacheNames[i] !== 'google-fonts') {
              caches.delete(cacheNames[i]);
            }
          }
        });
    }
    window.onbeforeunload = undefined;
    history.replace('/login');
    window.location.reload();
    logOut({}, this.headers);
  };

  pollHandler = () => {
    const { pingUser: pngUser } = this.props;
    if (!window.origin.includes('localhost')) {
      pngUser({}, this.headers);
    }
  };

  notifPollHandler = () => {
    const { getNotifs } = this.props;
    if (!window.origin.includes('localhost')) {
      getNotifs({
        skip: 0,
        limit: 15,
      }, this.headers);
    }
  };

  toggleState = (field) => {
    this.setState((prevState) => ({ [field]: !prevState[field] }));
  };

  // eslint-disable-next-line
  resetTimer = throttle(() => {
    clearTimeout(this.idleTimer);
    this.idleTimer = setTimeout(() => this.toggleActiveUser(true), 30000);
    const activeTime = moment().toISOString();
    localStorage.setItem('lastActive', activeTime);
  }, 2000, { leading: true });

  showSnackbar = (msg, variant = 'info', actions = [], duration = 10000) => {
    this.setState({
      open: true,
      msg,
      variant,
      actions,
    });
    setTimeout(() => this.onClose(), duration);
  };

  onClose = () => {
    this.setState({
      open: false,
      actions: [],
    });
  };

  toggleActiveUser = (active) => {
    if (active) {
      if (this.poller) {
        clearInterval(this.poller);
      }
      if (this.notifPoller) {
        clearInterval(this.notifPoller);
      }
      this.poller = setInterval(() => this.pollHandler(), 30000);
      this.notifPoller = setInterval(() => this.pollHandler(), 120000);
      this.setState({ timeoutDialog: false });
    } else {
      const lastActiveTime = localStorage.getItem('lastActive');
      if (!lastActiveTime || (moment().unix() - moment(lastActiveTime).unix()) > 30) {
        clearInterval(this.poller);
        clearInterval(this.notifPoller);
        this.setState({ timeoutDialog: true });
      }
    }
  };

  actionHandler = (action) => {
    if (action === 'feedback') {
      this.toggleState('feedbackDialog');
    } else if (action === 'logout') {
      this.logOutHandler();
    }
  };

  togglePerfModal = () => {
    this.toggleState('showPerfModal');
  };

  toggleRequestPackModal = () => {
    this.toggleState('showRequestPackModal');
  };

  toggleChaseScoreModal = () => {
    this.toggleState('showChaseScoreModal');
  };

  toggleTravClanQuoteModal = (usId) => {
    const { travClanQuoteDialog } = this.state;
    this.setState({ travClanQuoteDialog: !travClanQuoteDialog, travClanQuoteUsId: usId });
  };

  toggleDailyReportModal = () => {
    const { dailyReportDialog } = this.state;
    this.setState({ dailyReportDialog: !dailyReportDialog });
  };

  onDailyReportChange = (uuid, value) => {
    const { dailyReport } = this.state;
    const updatedEntries = dailyReport.data.entries.map((entry) => {
      if (entry.uuid === uuid) {
        return { ...entry, value };
      }
      return entry;
    });
    this.setState({ dailyReport: { ...dailyReport, data: { ...dailyReport.data, entries: updatedEntries } } });
  }

  onDailyReportSubmit = () => {
    const { dailyReport } = this.state;
    axios({
      method: 'put',
      url: `${baseURL}dailyReports/${dailyReport._id}`,
      headers: this.headers,
      data: {
        entries: dailyReport.data.entries,
      },
    }).then((response) => {
      this.setState({ dailyReport: response.data.dailyReport });
      this.showSnackbar('Daily report updated successfully', 'success');
      this.toggleDailyReportModal();
    }).catch(() => {
      this.showSnackbar('Failed to update daily report', 'error');
    });
  }

  render() {
    const {
      loginResp, isLogging, paramsMeta = {},
      location,
    } = this.props;
    const { travClanUrl } = paramsMeta;
    const {
      loggedIn,
      open,
      msg,
      variant,
      actions,
      notifPopup,
      showPerfModal,
      showRequestPackModal,
      showChaseScoreModal,
      error,
      errorInfo,
      offlineSnack,
      travClanQuoteDialog,
      travClanQuoteUsId,
      dailyReportDialog,
      dailyReport,
    } = this.state;
    const { expert = {} } = loginResp;

    if (error && error.toString()) {
      return (
        <>
          <h2>
            Something unexpected has happened, which caused this crash,
            <br />
            please contact tech team
            <span aria-label="sad" role="img">😢</span>
          </h2>
          <p>
            {errorInfo.componentStack}
          </p>
          <br />
          <p>{error}</p>
        </>
      );
    }
    if (isLogging || (loggedIn && !expert?._id)) {
      // if loggedIn, wait till expert roles are loaded
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    }

    let routes;
    if (expert && expert.roles
      && expert.roles.includes(ROLES.INVENTORY_CRUD) && expert.roles.length === 1) {      
      routes = null;
    } else {
      routes = (
        <Switch>
          <Route
            exact
            path="/dashboard"
            render={() => (
              <Dashboard
                showSnackbar={this.showSnackbar}
                toggleTravClanQuoteModal={this.toggleTravClanQuoteModal}
                toggleChaseScoreModal={this.toggleChaseScoreModal}
              />
            )}
          />
          <Route
            exact
            path="/request/:usid"
            render={() => <Dashboard showSnackbar={this.showSnackbar} />}
          />
          <Route
            exact
            path="/analytics"
            render={() => {
              return (
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    height: '100%',
                    flexDirection: 'column',
                    overflow: 'hidden',
                  }}
                >
                  <iframe
                    title="Meta Dashboard"
                    src={expert.iframeUrl}
                    frameBorder="0"
                    height="600"
                  />
                </div>
              );
            }}
          />
          {/* <Route exact path="/" render={() => <Dashboard showSnackbar={this.showSnackbar} />} /> */}
          <Route
            path="/itineraryMaker"
            render={() => <ItineraryMaker showSnackbar={this.showSnackbar} />}
          />
          <Route
            path="/ai-itinerary-builder/:requestUsId/:itineraryId"
            render={() => <AiItineraryBuilder expert={expert} showSnackbar={this.showSnackbar} />}
          />
          {
            <Route
              path="/templates"
              render={() => <TemplatesIndex showSnackbar={this.showSnackbar} />}
            />
          }
          {
            expert?.roles?.includes(ROLES.TEAM_LEAD)
              ? <Redirect from="/" to="/analytics" />
              : <Redirect from="/" to="/dashboard" />
          }
          {/* {expert?.roles
            && (expert.roles.includes(ROLES.INVENTORY_CRUD) || expert.roles.includes(ROLES.ADMIN))
            ? inventoryRoutes : null} */}
        </Switch>
      );
    }
    // Only show Navbar if not on AI Itinerary Builder page
    const hideNavbar = location.pathname.startsWith('/ai-itinerary-builder/');
    return (
      <ThemeProvider theme={theme}>
        <>
          <Dialog open={notifPopup}>
            <NotificationPermission
              onDismiss={() => this.toggleState('notifPopup')}
              onAllow={() => this.checkNotifPermission()}
            />
          </Dialog>
          {
            expert
              ? (
                <Dialog
                  open={showPerfModal}
                  maxWidth="xl"
                  onClose={this.togglePerfModal}
                >
                  <PerfModal
                    togglePerfModal={this.togglePerfModal}
                    toggleRequestPackModal={this.toggleRequestPackModal}
                    expert={expert}
                  />
                </Dialog>
              ) : null
          }
          {
            expert
              ? (
                <Dialog
                  open={showRequestPackModal}
                  maxWidth="xl"
                  onClose={this.toggleRequestPackModal}
                >
                  <RequestPackModal
                    toggleRequestPackModal={this.toggleRequestPackModal}
                    expert={expert}
                    showSnackbar={this.showSnackbar}
                    showRequestPackModal={showRequestPackModal}
                  />
                </Dialog>
              ) : null
          }
          <Dialog
            open={showChaseScoreModal}
            maxWidth="xl"
            onClose={this.toggleChaseScoreModal}
          >
            <ChaseScoreModal
              toggleChaseScoreModal={this.toggleChaseScoreModal}
            />
          </Dialog>
          <Dialog
            open={travClanQuoteDialog}
            onClose={() => this.toggleState('travClanQuoteDialog')}
            maxWidth="xl"
            aria-labelledby="trav clan quote"
          >
            <TravClanQuoteModal
              onClose={() => this.toggleState('travClanQuoteDialog')}
              travClanUrl={travClanUrl}
              travClanQuoteUsId={travClanQuoteUsId}
            />
          </Dialog>
          <Dialog
            open={dailyReportDialog}
            onClose={() => this.toggleState('dailyReportDialog')}
            maxWidth="xl"
            aria-labelledby="daily report"
          >
            <DailyReportModal
              onClose={() => this.toggleState('dailyReportDialog')}
              dailyReport={dailyReport}
              onDailyReportSubmit={this.onDailyReportSubmit}
              onDailyReportChange={this.onDailyReportChange}
            />
          </Dialog>
          {!hideNavbar && (
            <Navbar
              loggedIn={loggedIn}
              user={expert}
              actionHandler={this.actionHandler}
              togglePerfModal={this.togglePerfModal}
              toggleRequestPackModal={this.toggleRequestPackModal}
              expert={expert}
              toggleTravClanQuoteModal={this.toggleTravClanQuoteModal}
              toggleDailyReportModal={this.toggleDailyReportModal}
            />
          )}
          {loggedIn ? routes : <Auth showSnackbar={this.showSnackbar} />}
          <Snackbar
            open={open}
            actions={actions}
            message={msg}
            variant={variant}
            onClose={this.onClose}
          />
          <OfflineNotifier
            open={offlineSnack}
            handleClose={() => this.toggleState('offlineSnack')}
          />
        </>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.auth,
  ...state.common,
  notifications: state.notification.rawNotifications,
  unReadCount: state.notification.unReadCount,
});

const mapDispatchToProps = (dispatch) => ({
  updateToken: (params) => dispatch(updateToken(params)),
  logOut: (params, headers) => dispatch(logout(params, headers)),
  registerToken: (params, headers) => dispatch(registerNotifToken(params, headers)),
  pingUser: (params, headers) => dispatch(pingUser(params, headers)),
  getParamsMeta: (params, headers) => dispatch(getParams(params, headers)),
  getNotifs: (params, headers) => dispatch(getNotifications(params, headers)),
  getExpertDetails: (params, headers) => dispatch(getExpertDetails(params, headers)),
});

App.propTypes = {
  classes: PropTypes.object,
  logOut: PropTypes.func,
  loginResp: PropTypes.object,
  isLogging: PropTypes.bool,
  pingUser: PropTypes.func,
  updateToken: PropTypes.func,
  getParamsMeta: PropTypes.func,
  getNotifs: PropTypes.func,
  registerToken: PropTypes.func,
  history: PropTypes.object,
  notifications: PropTypes.array,
  getExpertDetails: PropTypes.func,
  getExpertDetailsError: PropTypes.bool,
  unReadCount: PropTypes.number,
  paramsMeta: PropTypes.object,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App));
